import { render } from "./ListePlacePage.vue?vue&type=template&id=36a709ac&ts=true"
import script from "./ListePlacePage.vue?vue&type=script&lang=ts"
export * from "./ListePlacePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__